import type {ExtendedPromise, OttoNexus} from "@otto-ec/global-resources/nexus";
import {apps} from "../index";
import type {OptOutAllMessages} from "./optOutAllMessages";
import type {OptOutGeneralVendorDto} from "./optOutGeneralVendorDto";
import type {OpenPreferenceCenterDto} from "./openPreferenceCenterDto";

export type CookieBannerRaw = {
    /**
 *
 */
    resurface(): ExtendedPromise;
    /**
 *
 */
    openPreferenceCenter(data: OpenPreferenceCenterDto): ExtendedPromise;
    /**
 *
 */
    optOutAll(data: OptOutAllMessages): ExtendedPromise;
    /**
 *
 */
    optOutGeneralVendor(data: OptOutGeneralVendorDto): ExtendedPromise;
}

export type CookieBanner = OttoNexus["apps"]["cookieBanner"]

/**
 *
 */
export const cookieBanner: CookieBanner = apps.cookieBanner;

/**
 *
 */
export const resurface: CookieBanner["resurface"] = cookieBanner.resurface

/**
 *
 */
export const openPreferenceCenter: CookieBanner["openPreferenceCenter"] = cookieBanner.openPreferenceCenter

/**
 *
 */
export const optOutAll: CookieBanner["optOutAll"] = cookieBanner.optOutAll

/**
 *
 */
export const optOutGeneralVendor: CookieBanner["optOutGeneralVendor"] = cookieBanner.optOutGeneralVendor